var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCoins = function SvgCoins(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_64.-Coins",
    "data-name": "64.-Coins",
    transform: "translate(-1.433 -2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69593",
    "data-name": "Group 69593",
    transform: "translate(1.933 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer-5",
    d: "M62.467,82.375c0,1.672-2.688,3.027-6,3.027s-6-1.355-6-3.027",
    transform: "translate(-38.467 -61.402)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer-1",
    d: "M11.984,27c0,1.668-2.683,3.021-5.992,3.021S0,28.668,0,27",
    transform: "translate(0 -20.126)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer-2",
    d: "M0,42H.021c.259,1.548,2.833,2.763,5.971,2.763S11.7,43.548,11.963,42h.021",
    transform: "translate(0 -31.307)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer-3",
    d: "M0,55H.021c.259,1.548,2.833,2.763,5.971,2.763S11.7,56.548,11.963,55h.021",
    transform: "translate(0 -40.997)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer-4",
    d: "M0,69H.021c.259,1.548,2.833,2.763,5.971,2.763S11.7,70.548,11.963,69h.021",
    transform: "translate(0 -51.433)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Layer-6",
    cx: 5.992,
    cy: 3.108,
    rx: 5.992,
    ry: 3.108,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Layer-7",
    d: "M98.057,13.65V31.118",
    transform: "translate(-74.057 -10.174)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer-8",
    d: "M3,55h.022c.26,1.551,2.839,2.769,5.983,2.769S14.728,56.551,14.988,55h.022",
    transform: "translate(-2.983 -40.997)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer-9",
    d: "M3,69h.022c.26,1.551,2.839,2.769,5.983,2.769S14.728,70.551,14.988,69h.022",
    transform: "translate(-2.983 -51.433)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer-10",
    d: "M14.942,82.375c0,1.672-2.688,3.027-6,3.027s-6-1.355-6-3.027",
    transform: "translate(-2.933 -61.402)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Layer-11",
    cx: 6.005,
    cy: 3.115,
    rx: 6.005,
    ry: 3.115,
    transform: "translate(0.017 7.129)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer-12",
    d: "M2.933,41.093V51.574",
    transform: "translate(-2.933 -30.631)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer-13",
    d: "M50.532,13.65V31.118",
    transform: "translate(-38.523 -10.174)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoins, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coins.928e4d27.svg";
export { ForwardRef as ReactComponent };